<template>
    <div>
        <div class="border p-4 rounded-sm mb-3">
            <b-row>
                <b-col sm="12">
                    <b-button class="mb-2" variant="primary" @click="openReferenceModal(null)" v-if="!isReadOnly">{{ $t('reference_add_btn') }}</b-button>
                </b-col>
                <b-col sm="12">
                    <b-table :empty-filtered-text="$t('no_result')"
                             :empty-text="$t('no_result')"
                             bordered
                             responsive
                             :items="referenceTableData"
                             :fields="referenceFields"
                             show-empty
                             class="mb-4 table-dropdown no-scrollbar border rounded">
                        <template #cell(buttons)="row">
                            <b-dropdown variant="link btn-sm" boundary="window" no-caret>
                                <template #button-content>
                                    <i class="ri-more-fill"></i>
                                </template>
                                <div id="dropdownListHead">
<!--                                    <b-dropdown-item @click="openReferenceModal(row.item)">-->
<!--                                        <i class="ri-edit-box-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('edit')}}-->
<!--                                    </b-dropdown-item>-->
                                    <b-dropdown-item @click="deleteReferance(row.item)">
                                        <i class="ri-delete-bin-2-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('delete')}}
                                    </b-dropdown-item>
                                </div>
                            </b-dropdown>
                        </template>
                        <template #cell(letter)="row">
                            <b-button variant="link" v-b-tooltip="$t('download')" v-if="row.item.id" @click="onDownloadReference(row.item.id)">
                                <i class="ri-download-2-line" style="font-size: 20px"></i>
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col cols="12">
                <b-alert variant="warning" show v-if="referenceInfo"><div v-html="referenceInfo"></div></b-alert>
            </b-col>
            <b-col cols="12">
                <b-alert variant="info" show>{{ footerInfo }}</b-alert>
            </b-col>

        </b-row>
        <div class="d-flex justify-content-center mt-3" v-if="!isReadOnly">
            <processing-button :processing="loading" variant="primary"
                               :label="$t('save_and_go').toUpper()" @click="saveReference" />
        </div>

        <CommonModal ref="referenceModal" size="lg">
            <template v-slot:CommonModalTitle>
                <div>{{ referenceModalTitle }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <ValidationObserver ref="referenceFormValidate">
                    <b-row>
                        <b-col cols="6">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group :label="$t('name')">
                                        <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.name"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('surname')">
                                        <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.surname"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('gsm_no')">
                                        <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.phone"
                                                          v-mask="'5## ### ## ##'"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('email')">
                                        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.email"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="12" lg="12" class="mt-5">
                                    <ValidationProvider name="letter" rules="required" v-slot="{errors}">
                                        <b-input-group class="mb-0 mt-1">
                                            <b-form-file v-model="referenceFormData.letter"
                                                         :placeholder="$t('letter_of_reference')"
                                                         :state="errors[0] ? false : null"
                                                         :accept="'.pdf,.doc,.docx'"
                                                         ref="fileInput3"
                                            />
                                            <b-input-group-append>
                                                <b-button variant="outline-secondary" @click="$refs.fileInput3.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-form-invalid-feedback v-if="errors[0]">
                                            <span v-html="errors[0]"></span>
                                        </b-form-invalid-feedback>
                                        <b-button variant="outline-primary" class="mb-4 mt-2" v-if="referenceFormData.letter && referenceFormData.id" @click="onDownloadReference(referenceFormData.id)">
                                            <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('file_download')}}
                                        </b-button>
                                    </ValidationProvider>
                                    <b-alert class="mb-4 mt-2" variant="info" show>
                                        {{ $t('bisep_file_upload_info') }}
                                    </b-alert>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="6">
                            <b-alert show variant="info">{{ $t('reference_letter_warning') }}</b-alert>
                        </b-col>
                        <b-col cols="12" class="d-flex justify-content-center mb-3 mt-4">
                            <b-button variant="primary" @click="addToReferences">{{ $t('save') }}</b-button>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </template>
        </CommonModal>
    </div>
</template>

<script>
import CommonModal from '@/components/elements/CommonModal'
import ProcessingButton from '@/components/elements/ProcessingButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import qs from "qs";
import ConstantService from "@/services/ConstantService";
import BisepService from "@/services/BisepService"

export default {
    name: "ReferenceTab",
    components: {
        CommonModal,
        ProcessingButton,
        ValidationObserver,
        ValidationProvider
    },
    props: {
        footerInfo: {
            type: String,
            default: ''
        },
        isReadOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            formData: {},
            referenceTableData: [],
            referenceFields: [
                { key: 'buttons', label: '' },
                { key: 'name', label: this.$t('name') },
                { key: 'surname', label: this.$t('surname') },
                { key: 'phone', label: this.$t('gsm_no') },
                { key: 'email', label: this.$t('email') },
                { key: 'letter', label: this.$t('letter_of_reference') }
            ],
            referenceModalTitle: null,
            referenceFormData: {},
            referenceInfo:null,
        }
    },

    mounted() {
      this.loadFormData()
      this.getReferences()
      if (this.isReadOnly) {
          this.referenceFields = this.referenceFields.filter(f => f.key !== 'buttons');
      }
    },
    methods: {
        loadFormData() {
            const data = this.getWithExpiry('bisep_app_data', true)
            if (data) {
                this.formData = data
            }
        },
        getPin() {
            return this.$store.getters['bisepApplication/getPin']
        },
        getReferences(){
            const data = {
                national_id: this.formData.national_id,
                pin: this.getPin()
            }
            BisepService.getReferenceList(data).then(response => {
                this.referenceTableData = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
            this.getReferenceWarning()
        },
        openReferenceModal(data) {
            if (data != null) {
                this.referenceModalTitle = this.$t('edit')
                this.referenceFormData = { ...data }
            } else {
                this.referenceModalTitle = this.$t('reference')
                this.referenceFormData = {}
            }
            this.$refs.referenceModal.$refs.commonModal.show()
        },
        async addToReferences() {
            const isValid = await this.$refs.referenceFormValidate.validate()
            if (isValid) {
                this.loading = true
                const formData = new FormData()
                formData.append('national_id', this.formData.national_id)
                formData.append('pin', this.getPin())
                formData.append('name', this.referenceFormData.name)
                formData.append('surname', this.referenceFormData.surname)
                formData.append('phone', this.referenceFormData.phone ? this.referenceFormData.phone.replace(/[^\d]/g, '') : '')
                formData.append('email', this.referenceFormData.email || '')
                if (this.referenceFormData.letter) {
                    formData.append('letter', this.referenceFormData.letter)
                }

                if (Object.prototype.hasOwnProperty.call(this.referenceFormData, "id")) {
                    formData.append('bisep_application_reference_id', this.referenceFormData.id)
                }

                BisepService.addReference(formData).then(response => {
                    this.$toast.success(this.$t('successfully_saved'))
                    this.getReferences()
                    this.$refs.referenceModal.$refs.commonModal.hide()
                    this.referenceFormData = {}
                    this.$refs.referenceFormValidate.reset()
                }).catch(e => {
                    this.showErrors(e, this.$refs.referenceFormValidate)
                }).finally(() => {
                    this.loading = false
                })
            }
        },
        deleteReferance(data) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    const payload = {
                        national_id: this.formData.national_id,
                        pin: this.getPin(),
                        bisep_application_reference_id: data.id
                    }
                    BisepService.deleteReference(payload).then(() => {
                        this.$toast.success(this.$t('successfully_deleted'))
                        this.getReferences()
                    }).catch(e => {
                        this.showErrors(e, null)
                    })
                }
            })
        },
        saveReference() {
            this.$emit('success')
        },
        onDownloadReference(id) {
            const data = {
                national_id: this.formData.national_id,
                pin: this.getPin(),
                bisep_application_reference_id: id
            }
            BisepService.downloadReferenceLetter(data).then(response => {
                this._downloadFile(response, this.$t('reference_letter')+'.'+(response.headers.file_extension))
            }).catch(e => {
                this.showErrors(e, null, true)
            })
        },
        getReferenceWarning() {
            const config = {
                params: {
                    'key': 'bisep_application.reference_warning_message'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.referenceInfo = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },
    }
}
</script>
